import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Destination = {
  id: string;
  code: string;
};

export type WebDestinationsState = {
  value: string | null;
};

const initialState: WebDestinationsState = {
  value: '',
};

function setDestinationsValueFunction(
  state: WebDestinationsState,
  action: PayloadAction<WebDestinationsState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

const slice = createSlice({
  name: 'hotelImage.manager.destinations',
  initialState,
  reducers: {
    setDestinationsValue: setDestinationsValueFunction,
  },
});

export const { setDestinationsValue } = slice.actions;

export default slice.reducer;
